export default "__VITE_ASSET__BxvV5iJB__"